import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/zingly/Navbar";
import { Hero } from "./components/zingly/Hero";
import { MenuSection } from "./components/zingly/MenuSection";
import { About } from "./components/zingly/About";
import { Reviews } from "./components/zingly/Reviews";
import { OrderPlatforms } from "./components/zingly/OrderPlatforms";
import { Contact } from "./components/zingly/Contact";
import { Footer } from "./components/zingly/Footer";
import { OrderModal } from "./components/zingly/OrderModal";

const Home = () => {
  const [orderItem, setOrderItem] = useState(null);
  return (
    <div className="bg-[#FFF8F1] font-sans" data-testid="zingly-home">
      <Navbar />
      <Hero />
      <MenuSection onOrder={(item) => setOrderItem(item)} />
      <About />
      <Reviews />
      <OrderPlatforms />
      <Contact />
      <Footer />
      <OrderModal item={orderItem} onClose={() => setOrderItem(null)} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
